import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./css/MyProfile.css"; // Import CSS for styling
import BottomTabs from "../BottomTabs/BottomTabs";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const MyProfile = () => {
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const [selectedAvatar, setSelectedAvatar] = useState("avatar1");
  const [profileData, setProfileData] = useState({
    name: "",
    email: "",
    gender: "",
    birthDate: "2000-01-01",
  });
  const [imageData, setImageData] = useState({ userImage: null });
  const [preview, setPreview] = useState(null);
  const [userWantToUpdateRecords, setUserWantToUpdateRecords] = useState(false);
  const [userWantToEditRecords, setUserWantToEditRecords] = useState(false);
  //
  //
  const handleUnsubscribeClick = () => {
    navigate("/unsubscribe"); // or wherever your policy page is routed
  };
  //

  const handlePolicyClick = () => {
    navigate("/policy"); // or wherever your policy page is routed
  };

  useEffect(() => {
    if (
      localStorage.getItem("image") == null ||
      localStorage.getItem(
        "image" == "null" || localStorage.getItem("image") == ""
      )
    ) {
      localStorage.setItem(
        "image",
        "https://cdn-icons-png.flaticon.com/128/1177/1177568.png"
      );
    }
  });

  const handleFieldClick = () => {
    inputRef.current.focus();
    inputRef.current.value = "2000-01-01";
    profileData.birthDate = "2000-01-01";
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    console.log(file);
    if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
      const isValidSize = file.size <= 10 * 1024 * 1024; // 10 MB
      if (!isValidSize) {
        alert("File size exceeds 10 MB!");
        return;
      }
      setImageData((prevState) => {
        const updatedProfile = { ...prevState, userImage: file };
        console.log("Updated Profile Data:", updatedProfile);
        return updatedProfile;
      });
      setPreview(URL.createObjectURL(file));
    } else {
      alert("Only .png and .jpg files are allowed!");
    }
  };

  const handleAvatarChange = (event) => {
    setSelectedAvatar(event.target.value);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    // console.log(name, value);
    setProfileData((prevData) => {
      const updatedData = { ...prevData, [name]: value };
      // console.log("Updated profileData:", updatedData);
      return updatedData;
    });
    // console.log(profileData);
  };
  //
  //Logout function
  const Logout = () => {
    localStorage.clear();
    navigate("/");
  };
  //
  const saveRecords = async () => {
    setUserWantToUpdateRecords(true);
    if (
      profileData.name === null ||
      profileData.name === "" ||
      profileData.email === null ||
      profileData.email === "" ||
      profileData.gender === null ||
      profileData.gender === "" ||
      profileData.birthDate === null ||
      profileData.birthDate === ""
    ) {
      if (imageData.userImage === null) {
      } else {
        toast.error("Each fields is required");
        setUserWantToUpdateRecords(false);
        return;
      }
    }

    if (validateForm(profileData.name, profileData.email) === false) {
      setUserWantToUpdateRecords(false);
      return;
    }
    const fileData = new FormData();
    fileData.append("name", profileData.name);
    fileData.append("msisdn", localStorage.getItem("no-msisdn"));
    fileData.append("email", profileData.email);
    fileData.append("gender", profileData.gender);
    fileData.append("userImage", imageData.userImage);
    localStorage.setItem("birthDate", profileData.birthDate);
    fileData.append("birthDate", profileData.birthDate);
    // if(imageData.userImage instanceof File){

    console.log("----- " + fileData);
    // Save Record if Records is not exist else update
    try {
      await fetch(
        "https://gamenow-backend.ntgarage.com/api/users/create-user-profile",
        {
          method: "POST",
          body: fileData,
        }
      )
        .then((response) => response.json()) // Convert response to JSON
        .then((data) => {
          console.log(data.message);
          toast.success(data.message);
          setProfileData({
            name: "",
            email: "",
            gender: "",
            birthDate: "",
          });
          setImageData({ imageData: null });
          setPreview(null);
        })
        .catch((error) => {
          console.error("Error:", error);
          toast.error("An error occurred while saving the profile");
        });
    } catch (error) {
    } finally {
      setUserWantToUpdateRecords(false);
      setTimeout(() => window.location.reload(), 200);
    }

    localStorage.setItem("UserData", JSON.stringify(profileData));
    // }
    // else
    // {
    //   toast.error("Image Required", {autoClose: 5000});
    //       setUserWantToUpdateRecords(false);
    //     return;
    // }
  };
  const validateForm = (name, email) => {
    console.log("nameRegex  Received the email", profileData.email);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const nameRegex = /^[A-Za-z\s]+$/; // Allows only letters and spaces

    if (!emailRegex.test(email)) {
      toast.error("Invalid email format! Please enter a valid email.");
      return false;
    }

    // if (!nameRegex.test(name)) {
    //   toast.error("Name should not contain numbers or special characters!");
    //   return false;
    // }

    return true;
  };

  useEffect(() => {
    const fetchUserProfile = async () => {
      if (
        profileData.name !== null ||
        profileData.name !== "" ||
        profileData.email !== null ||
        profileData.email !== "" ||
        profileData.gender !== null ||
        profileData.gender !== "" ||
        imageData.userImage !== null ||
        profileData.birthDate !== null ||
        profileData.birthDate !== ""
      ) {
        if (
          profileData.name !== null &&
          profileData.name !== "" &&
          profileData.email !== null &&
          profileData.email !== "" &&
          profileData.gender !== null &&
          profileData.gender !== "" &&
          profileData.birthDate !== null &&
          profileData.birthDate !== ""
        ) {
          return;
        }
      }

      setUserWantToUpdateRecords(true);

      const msisdn = localStorage.getItem("no-msisdn");

      try {
        const response = await fetch(
          `https://gamenow-backend.ntgarage.com/api/users/get-user-by-msisdn?msisdn=${msisdn}`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
          }
        );

        if (!response.ok) throw new Error("Failed to fetch user data");

        const data = await response.json();
        console.log("Fetched Data:", data);

        if (data?.user) {
          const { name, email, gender, userImage, birthDate } = data.user;

          // Ensure userImage is in Base64 format with a proper prefix
          const imageUrl = userImage || null;

          setProfileData({
            name: name || "",
            email: email || "",
            gender: gender || "",
            birthDate: birthDate || "",
          });

          localStorage.setItem("image", imageUrl);
          console.log("Profile Data Updated:", name, email, gender);
        } else {
          console.log("No Profile Data Found");
        }
      } catch (error) {
        console.error("Fetch Error:", error);
        toast.error("An error occurred while fetching the profile");
      } finally {
        setUserWantToUpdateRecords(false);
      }
    };

    fetchUserProfile();
  }, []);

  return (
    <div className="profile-container">
      <div
        className="avatar-Box"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="avatar-container-picture">
          <img
            title="Press image to choose file"
            src={
              preview !== null
                ? preview
                : localStorage.getItem("image") &&
                  localStorage.getItem("image") !== "null"
                ? localStorage.getItem("image")
                : "https://cdn-icons-png.flaticon.com/128/1177/1177568.png"
            }
            alt="User Icon"
            className="user-icon"
            onClick={() => document.getElementById("file-input").click()}
          />

          <input
            type="file"
            id="file-input"
            accept=".png, .jpg, .jpeg"
            onChange={handleFileChange}
            style={{ display: "none" }}
            disabled={userWantToEditRecords}
          />

          <div
            className="EditCamBox"
            onClick={() => document.getElementById("file-input").click()}
          >
            <img
              src="https://cdn-icons-png.flaticon.com/128/45/45010.png"
              alt="Edit Camera Icon"
              className="EditCam"
            />
          </div>
        </div>
      </div>
      {userWantToEditRecords && (
        <p style={{ textAlign: "center", fontWeight: "bold", color: "#fff" }}>
          Click the picture to change{" "}
        </p>
      )}

      {!userWantToEditRecords && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <h3 style={{ color: "white" }}>
            MSISDN: {localStorage.getItem("no-msisdn")}{" "}
          </h3>
        </div>
      )}

      <div className="profile-form">
        <div className="form-group">
          <label htmlFor="input-name">Name</label>
          <input
            type="text"
            name="name"
            id="input-name"
            className="input-field"
            placeholder="Enter your Name"
            value={profileData.name}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="input-dob">Date of Birth</label>
          <input
            type="date"
            id="input-dob"
            className="input-field"
            ref={inputRef}
            name="birthDate"
            onClick={handleFieldClick}
            value={profileData.birthDate}
            onChange={handleChange}
          />
        </div>
        {userWantToUpdateRecords && (
          <div
            style={{
              display: userWantToUpdateRecords ? "block" : "none",
              position: "fixed",
              top: "0",
              left: "0",
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: "999",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <FontAwesomeIcon icon={faSpinner} spin size="3x" color="white" />
          </div>
        )}
        <div className="form-group">
          <label htmlFor="input-email">Email</label>
          <input
            type="email"
            name="email"
            id="input-email"
            className="input-field"
            placeholder="Enter your email"
            value={profileData.email}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label htmlFor="input-gender">Gender</label>
          <select
            id="input-gender"
            className="input-field"
            value={profileData.gender}
            onChange={handleChange}
            name="gender"
          >
            <option
              value=""
              className="input-field-select"
              style={{ color: "black" }}
            >
              Select your gender
            </option>
            <option
              value="male"
              className="input-field-select"
              style={{ color: "black" }}
            >
              Male
            </option>
            <option
              value="female"
              className="input-field-select"
              style={{ color: "black" }}
            >
              Female
            </option>
            <option
              value="other"
              className="input-field-select"
              style={{ color: "black" }}
            >
              Other
            </option>
          </select>
        </div>

        <div className="form-group-btn-box">
          <button type="submit" className="save-btn" onClick={saveRecords}>
            Save
          </button>
        </div>
        <p className="note">
          For more details about your subscription or to{" "}
          <button onClick={handleUnsubscribeClick} className="inlineLink">
            unsubscribe
          </button>
          , and how to manage your preferences, please refer to our{" "}
          <button onClick={handlePolicyClick} className="inlineLink">
            policy
          </button>
          .
        </p>
      </div>
      <BottomTabs />
    </div>
  );
};

export default MyProfile;
